<template>
  <div
    class="popupLeft"
    :class="{
      white: !popupDark,
      moodboard: popupType === 'moodboard',
      moreInfo: popupType === 'moreInfo',
    }"
  >
    <button class="btn-hide" @click="$emit('closePopup')"></button>
    <popup-tag
      v-if="popupType === 'tag'"
      :popupContent="popupContent"
      :white="!popupDark"
    />
    <popup-selectie
      v-else-if="popupType === 'selectie'"
      :popupContent="popupContent"
      :white="!popupDark"
    />
    <popup-moodboard
      v-else-if="popupType === 'moodboard'"
      :popupContent="popupContent"
      :white="!popupDark"
    />
    <popup-res-more-info
      v-else-if="popupType === 'moreInfo'"
      :popupContent="popupContent"
    />
  </div>
</template>

<script>
import PopupTag from "@/components/PopupLeft/PopupTag.vue";
import PopupSelectie from "@/components/PopupLeft/PopupSelectie.vue";
import PopupMoodboard from "@/components/PopupLeft/PopupMoodboard.vue";
import PopupResMoreInfo from "@/components/PopupLeft/PopupResMoreInfo.vue";
export default {
  name: "PopUpLeft",
  components: {
    PopupTag,
    PopupSelectie,
    PopupMoodboard,
    PopupResMoreInfo,
  },
  props: {
    sortedSubCat: String,
    popupType: String,
    popupDark: Boolean,
    popupContent: Object,
  },
};
</script>
<style lang="sass" scoped>
.moreInfo
  width: 90% !important
  max-width: 1000px !important
.moodboard
  width: 50% !important
  max-width: 800px !important
  > div
    direction: rtl
    padding-left: 20px
    padding-right: 50px
    height: 100%
    width: 100%
    overflow-y: auto
    box-sizing: border-box
.popupLeft
  top: 50px
  bottom: 90px
  position: absolute
  width: 50%
  background-color: $black
  box-sizing: border-box
  color: $white
  z-index: 10003
  > div
    overflow-y: auto
    overflow-x: hidden
    direction: rtl
    height: 100%
    padding-right: 75px
    padding-left: 30px
    padding-top: 22px
    box-sizing: border-box
    .body
      direction: ltr
  .btn-hide
    position: absolute
    left: calc(100% - 10px)
    z-index: 10
    top: 27px
    height: 24px
    width: 24px
    border: none
    background-color: $white
    border-radius: 12px
    &:after
      content: ''
      border: 1px solid $black
      border-width: 0 3px 3px 0
      display: inline-block
      padding: 2px
      margin-left: 1px
      margin-bottom: 2px
      transform: rotate(135deg)
      -webkit-transform: rotate(135deg)
  &.white
    background-color: $white
    color: $black
    box-shadow: 0 2px 7px 0 rgba(0,0,0,0.3)
    > div
      padding-right: 30px
    .btn-hide
      background-color: $black
      &:after
        border: 1px solid $white
        border-width: 0 3px 3px 0

@media only screen and (min-width: 576px)
  .moodboard
  .moreInfo
    width: 80% !important
  .popupLeft
    .btn-hide

@media only screen and (min-width: 768px)
  .moodboard
  .popupLeft
    .btn-hide

@media only screen and (min-width: 992px)
  .moodboard
  .moreInfo
    width: 60% !important
  .popupLeft
    width: 40%
    .btn-hide

@media only screen and (min-width: 1200px)
  .moodboard
  .popupLeft
    width: 35%
    &.white
      .popupLeft
        > div
          padding-left: 75px
      .btn-hide

@media only screen and (min-width: 1660px)
  .moreInfo
    width: 45% !important
  .moodboard
    width: 40%
  .popupLeft
    width: 28%
    .btn-hide
</style>
